<div class="uploader">
    <div class="card" *ngFor="let img of images; let i = index" draggable="true" (dragstart)="onDragStart(i)" (drop)="onDrop(i)">
        <button class="delete" (click)="removeImage(i)">
            <i class="fa fa-trash-o" aria-hidden="true"></i>
        </button>
        <div class="card-body" (dragover)="$event.preventDefault()">
            <img *ngIf="img.url" [src]="img.url" />
            <div *ngIf="img.loading">Subiendo...</div>
        </div>
        <div class="order-container">
            <span class="order">{{ i + 1 }}</span>
        </div>
        <div class="card-footer">
            <input type="text" [(ngModel)]="img.altText" placeholder="Texto alternativo" class="alt-input" (ngModelChange)="emitResult()"/>
        </div>
    </div>

    <div class="card add" *ngIf="images.length < maxImages" (click)="openFileDialog()">
        +
    </div>

    <input type="file" #fileInput accept="image/*" hidden (change)="onFileSelected($event)" />
</div>

<app-image-cropper-modal *ngIf="showCropper && selectedFileBase64" [imageBase64]="selectedFileBase64"
    (cropped)="handleCropped($event)" (cancel)="cancelCrop()">
</app-image-cropper-modal>